import { MaterialFactor } from 'models/mooring/MaterialFactor';

const ACCIDENT_FACTOR = 1.5;

type MblType = {
  MblRopes?: number;
  MblSinkRopes?: number;
  MblStraps?: number;
  MblChainShackleConnectionPlates?: number;
  MblUsedChainRopeWithKnot?: number;
};

type MinMblAnchoringType = {
  MblAnchoring?: number;
} & MblType;

const calculate = (value: number) => +value.toFixed(2);
export const calculateFactorsMbl = (dimForce: number, line: MblType, materialFactors: MaterialFactor, isAccident?: boolean) => {
  const accident = isAccident ? ACCIDENT_FACTOR : 1;

  line.MblRopes = calculate(dimForce * (materialFactors.RopeFactor / accident));
  line.MblSinkRopes = calculate(dimForce * (materialFactors.SinkRopeFactor / accident));
  line.MblStraps = calculate(dimForce * (materialFactors.StrapFactor / accident));

  line.MblChainShackleConnectionPlates = calculate(dimForce * (materialFactors.ChainFactor / accident));
  line.MblUsedChainRopeWithKnot = calculate(dimForce * (materialFactors.RopeWithKnotFactor / accident));
};

export const calculateFactorsMblAnchoring = (
  dimForce: number,
  line: MinMblAnchoringType,
  materialFactors: MaterialFactor,
  isAccident?: boolean
) => {
  const accident = isAccident ? ACCIDENT_FACTOR : 1;

  calculateFactorsMbl(dimForce, line, materialFactors, isAccident);
  line.MblAnchoring = calculate(dimForce * (materialFactors.MountainBoltAndDragAnchorFactor / accident));
};
